module.exports = __webpack_public_path__ + "img/IMG_2035-1200w.8e0ef6fa.jpg";